import React, { Component } from 'react';
import { HashRouter, Route, Link } from "react-router-dom";

import IslenskuKennslaKort from './components/IslenskuKennslaKort';

class App extends Component {
	constructor(props) {
		super(props);

		this.state = {
			searchParams: {}
		};
	}

	render() {
		return (
			<IslenskuKennslaKort />
		);
	}
}

export default App;
